import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { path } from 'ramda'
import React, { Fragment } from 'react'

import TablePagination from '@/app/component/atom/table-pagination'
import ContentLayout from '@/app/component/layout/content'
import { TablePagination as TablePaginationType } from '@/app/types'

type Props = {
  children: React.ReactNode
  emptyMessage: React.ReactNode
  loading: boolean
  pageSize: number
  pagination?: TablePaginationType
  style?: React.CSSProperties
}

const TableLayout: React.FC<Props> = ({ loading, pageSize, pagination, emptyMessage, children, style = {} }: Props) => {
  if (!loading && pageSize === 0) {
    return (
      <Paper>
        <EmptyWrap>
          <Typography color="textSecondary" variant="h6" align="center">
            {emptyMessage}
          </Typography>
        </EmptyWrap>
      </Paper>
    )
  }
  return (
    <Fragment>
      <Container style={style}>
        <Wrap>
          <Paper style={{ boxShadow: 'none', overflowX: 'scroll' }}>{children}</Paper>
        </Wrap>
      </Container>
      {pagination && pageSize > 0 && (
        <ContentLayout>
          <PaginationWrap>
            <TablePagination {...pagination} />
          </PaginationWrap>
        </ContentLayout>
      )}
    </Fragment>
  )
}

const Container = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
})

const Wrap = styled('div')(({ theme }) => ({
  width: '100%',
  '& th, & td': {
    fontSize: '1rem',
  },
  '& tbody tr:hover': {
    cursor: 'pointer',
    backgroundColor: path(['palette', 'action', 'hover'], theme),
  },
}))

const EmptyWrap = styled('div')({
  padding: '3.05rem 1rem',
})

const PaginationWrap = styled('div')({
  paddingRight: '3rem',
})

export default TableLayout
